import { App } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../utils/api";
import { getApplicantDetailsQueryKey } from "./useGetApplicantDetailsQuery";

export interface ChangeCoursePayload {
  applicantId: string;
  newProgramId: number;
  newConcentrationId?: number | null;
  reason: string;
}

const changeCourse = async (payload: ChangeCoursePayload) => {
  return (await api.put("/StudentInfo/ChangeCourse", payload)).data as Response;
};

export const useChangeCourseMutation = () => {
  const { notification } = App.useApp();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: changeCourse,
  });

  const changeCourseHandler = async (payload: ChangeCoursePayload) => {
    try {
      const response = await mutation.mutateAsync(payload);

      notification.success({
        message: "Success",
        description: response?.message || "Course changed successfully",
      });

      await queryClient.invalidateQueries({
        queryKey: getApplicantDetailsQueryKey(),
      });

      return response;
    } catch (error: any) {
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.message || "Failed to change course",
      });
      throw error;
    }
  };

  return {
    ...mutation,
    changeCourseHandler,
    isLoading: mutation.isPending,
  };
};

export default useChangeCourseMutation;
